import { call, put } from "redux-saga/effects";
import * as Api from "../../api";
import * as actions from "../actions";

export default function* markDocumentReadGB({ payload }) {
  yield put(actions.setGreatBearReadingLoading(true));

  try {
    const filename = payload;
    yield call(Api.markDocumentRead, {
      document_read: filename,
      greatbear: true,
    });
    yield put(actions.setGreatBearReadingLoading(false));
  } catch (error) {
    yield put(actions.addError("Reading List GB", error));
    yield put(actions.setGreatBearReadingLoading(false));
  }
}
